export const UserStatus = {
  ACTIVE: 'activated',
  BLOCKED: 'blocked',
  NEW: 'new',
  PASSWORD_RESET: 'password_reset',
  PASSWORD_RESET_REQUESTED: 'password_reset_request',
  TERMINATED: 'terminated'
};

export default UserStatus;
